// Product-recommendations slider
window.initMainProductRecommendationsSlider = function (wrapper) {
	var container = wrapper || document.querySelector(".main-product-recommendations-slider-wrapper");
	if (!container) return;
	var items = container.querySelectorAll(".main-product-recommendation-item");
	var left = container.querySelector(".main-product-recommendations-arrow.left");
	var right = container.querySelector(".main-product-recommendations-arrow.right");
	var paginationDashes = container.querySelectorAll(".main-product-recommendations-pagination .main-pagination-dash");
	var current = 0;

	function showItem(idx) {
		items.forEach(function (el, i) {
			el.style.display = i === idx ? "block" : "none";
		});
		paginationDashes.forEach(function (dash, i) {
			dash.classList.toggle("active", i === idx);
		});
		if (left) left.disabled = idx === 0;
		if (right) right.disabled = idx === items.length - 1;
	}

	if (items.length) {
		showItem(current);
		if (left) {
			left.onclick = function () {
				if (current > 0) {
					current--;
					showItem(current);
				}
			};
		}
		if (right) {
			right.onclick = function () {
				if (current < items.length - 1) {
					current++;
					showItem(current);
				}
			};
		}
	}
};

// Announcement bar close functionality
function closeAnnouncementBar() {
	const closeAnnouncementBtn = document.querySelector(".announcement-bar__close");
	if (closeAnnouncementBtn) {
		closeAnnouncementBtn.addEventListener("click", () => {
			const announcementBarEl = closeAnnouncementBtn.closest("announcement-bar");

			if (announcementBarEl) {
				announcementBarEl.remove();
				sessionStorage.setItem('announcementBarClosed', 'true');
			}
		});
	}
}

document.addEventListener("DOMContentLoaded", function () {
	window.initMainProductRecommendationsSlider();
	closeAnnouncementBar();
});
